<div class="validator__container">
  <app-file-review-section [section]="FileReviewSectionType.PendingFiles" 
                            [pendingFiles]="pendingFilesWithTotal" 
                            [showLoader]="showPendingFilesLoader"
                            [user]="user"
                            (onPendingFilesPageTraversal)="onPendingFilesPagingTraversal($event)"></app-file-review-section>
</div>
